
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 3C7.55228 3 8 3.44772 8 4V12.127C8 14.7738 8.56095 16.4244 9.5514 17.4305C10.5383 18.4331 12.1534 19 14.75 19H18.75C19.3023 19 19.75 19.4477 19.75 20C19.75 20.5523 19.3023 21 18.75 21H14.75C11.9166 21 9.65672 20.3885 8.1261 18.8336C6.59905 17.2823 6 14.9964 6 12.127V4C6 3.44772 6.44772 3 7 3Z","fill":"#16171F"}})])
          )
        }
      }
    